import dayjs from 'dayjs'
import { PLAYER_NOTIFICATIONS } from '~/utils/api-response/player'

// State
export const state = () => ({
  notifications: [],
  cancelToken: {}
})

// Actions
export const actions = {
  getNotifications({ commit, state }, params) {
    PLAYER_NOTIFICATIONS.data.forEach(el => {
      el.created_at = dayjs().format('YYYY-MM-DD')
      el.expiration = dayjs().format('YYYY-MM-DD')
    })
    commit('setNotifications', PLAYER_NOTIFICATIONS.data)
    return PLAYER_NOTIFICATIONS.data
  },
  deleteNotification({ state, commit }, id) {
    const notifications = state.notifications.filter(el => el._id !== id)
    commit('setNotifications', notifications)
    return true
  },
  clearAllNotifications({ commit }, id) {
    commit('setNotifications', [])
  },
  onDeleteNotificationList({ commit, state }, id) {
    const notifications = state.notifications.filter(el => el._id !== id)
    commit('setNotifications', notifications)
  },
  async onViewNotification({ dispatch }, id) {}
}

// Mutations
export const mutations = {
  setNotifications: (state, data) => {
    state.notifications = data
  },
  setCancelTokens: (state, data) => {
    const oldData = { ...state.cancelToken }
    state.cancelToken = {
      ...oldData,
      ...data
    }
  }
}
